import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VideoService {
  constructor(public db: AngularFireDatabase) {}

  getAllCarrousel() {
    return this.db
      .list('carousel/carousel1')
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({ key: c.payload, ...(c.payload.val() as {}) }))
        )
      );
  }

  getAllCourses() {
    return this.db
      .list('courses/')
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({ key: c.payload, ...(c.payload.val() as {}) }))
        )
      );
  }
  getCoursesbyTitle(title: string) {
    return this.db
      .list('courses', (ref) => ref.orderByChild('titleCourse').equalTo(title))
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({ key: c.payload, ...(c.payload.val() as {}) }))
        )
      );
  }

  getAllReplayWebinars() {
    return this.db
      .list('ReplayWebinars/')
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({ key: c.payload, ...(c.payload.val() as {}) }))
        )
      );
  }
  canShowReplayWebinar(webinar) {
    if (!webinar.webinarDate || !webinar.webinarDateEnd) {
      return true;
    }
    const now = new Date();
    const webinarDate = new Date(webinar.webinarDate);
    const webinarDateEnd = new Date(webinar.webinarDateEnd);
    return now > webinarDate && now < webinarDateEnd;
  }

  getCoursesById(CoursesKey) {
    return this.db.object('courses/' + CoursesKey).valueChanges();
  }

  getWebinarById(WebinarKey) {
    return this.db.object('ReplayWebinars/' + WebinarKey).valueChanges();
  }

  getVideoByName(name: string) {
    return this.db
      .list('videos', (ref) => ref.orderByChild('nom').equalTo(name))
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({ key: c.payload, ...(c.payload.val() as {}) }))
        )
      );
  }

  getVideo(videoKey) {
    return this.db.object('videos/' + videoKey).valueChanges();
  }

  // Writing to a child of a deleted course (e.g. counterView/favorites) would
  // recreate its parent node as an empty stub in RTDB, leaving orphan "courses"
  // with no titleCourse that crash the listing pages. Only write if the course
  // still exists (titleCourse present = real course, not a resurrected stub).
  private async courseExists(coursesId: string): Promise<boolean> {
    const snap = await this.db.database
      .ref('courses/' + coursesId + '/titleCourse')
      .once('value');
    return snap.exists();
  }

  private async webinarExists(webinarId: string): Promise<boolean> {
    const snap = await this.db.database
      .ref('ReplayWebinars/' + webinarId + '/titleCourse')
      .once('value');
    return snap.exists();
  }

  async updateCourseForCounterVideo(coursesId, userId, data) {
    if (!(await this.courseExists(coursesId))) {
      return;
    }
    return this.db.database
      .ref('courses/' + coursesId + '/counterView/' + userId)
      .update(data);
  }

  async updateWebinarForCounterVideo(webinarId, userId, data) {
    if (!(await this.webinarExists(webinarId))) {
      return;
    }
    return this.db.database
      .ref('ReplayWebinars/' + webinarId + '/counterView/' + userId)
      .update(data);
  }

  async updateCourseFromFavorites(coursesId, userId, data) {
    if (!(await this.courseExists(coursesId))) {
      return;
    }
    return this.db.database
      .ref('courses/' + coursesId + '/favorites/' + userId)
      .update(data);
  }

  videoSearchBarFilter(event, videoList) {
    const searchTerm = event.target.value;
    let listReturn: any;

    if (!searchTerm) {
      return videoList;
    }

    listReturn = videoList.filter((t) => {
      let specialtyString = '';
      let doctorString = '';
      t.docteur.map(
        (p) =>
          (specialtyString = specialtyString + p.speciality.toLowerCase() + ' ')
      );
      t.docteur.map(
        (d) => (doctorString = doctorString + d.nom.toLowerCase() + ' ')
      );
      const bool =
        t.titleCourse.toLowerCase().includes(searchTerm.toLowerCase()) ||
        specialtyString.includes(searchTerm.toLowerCase()) ||
        (t.product &&
          t.product.some((product) =>
            product.name.toLowerCase().includes(searchTerm.toLowerCase())
          )) ||
        doctorString.includes(searchTerm.toLowerCase());
      return bool;
    });
    return listReturn;
  }
  eventSearchBarFilter(event, eventList) {
    const searchTerm = event.target.value;
    let listReturn: any;

    if (!searchTerm) {
      return eventList;
    }

    listReturn = eventList.filter((t) => {
      const bool =
        t.titleEvent.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.location.toLowerCase().includes(searchTerm.toLowerCase());
      return bool;
    });
    return listReturn;
  }
}
